var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { autoUpdate, computePosition, flip, offset, shift } from '@floating-ui/dom';
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { SdsContextMenuExpandableItem } from './item/sds-cm-expandable-item.lit';
import { SdsContextMenuItem } from './item/sds-cm-item.lit';
import { focusNextItem, focusPreviousItem, cleanMenuItemsFocus, scrollFocusedItemIfNeeded, } from '../dropdown/menu-items-state-handler';
import styles from './sds-context-menu.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-context-menu` is a web component that provides a customizable context menu
 * for displaying interactive actions or options. The menu can be triggered by user
 * clicking on the trigger. It supports hierarchical
 * items, grouping, and selection behavior.
 *
 * @tag sds-context-menu
 */
let SdsContextMenu = (() => {
    var _SdsContextMenu_position_accessor_storage, _SdsContextMenu_offset_accessor_storage, _SdsContextMenu_width_accessor_storage, _SdsContextMenu_minWidth_accessor_storage, _SdsContextMenu_maxHeight_accessor_storage, _SdsContextMenu_maxWidth_accessor_storage, _SdsContextMenu_identifier_accessor_storage, _SdsContextMenu_opened_accessor_storage, _SdsContextMenu_container_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-context-menu')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _position_decorators;
    let _position_initializers = [];
    let _position_extraInitializers = [];
    let _offset_decorators;
    let _offset_initializers = [];
    let _offset_extraInitializers = [];
    let _width_decorators;
    let _width_initializers = [];
    let _width_extraInitializers = [];
    let _minWidth_decorators;
    let _minWidth_initializers = [];
    let _minWidth_extraInitializers = [];
    let _maxHeight_decorators;
    let _maxHeight_initializers = [];
    let _maxHeight_extraInitializers = [];
    let _maxWidth_decorators;
    let _maxWidth_initializers = [];
    let _maxWidth_extraInitializers = [];
    let _identifier_decorators;
    let _identifier_initializers = [];
    let _identifier_extraInitializers = [];
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let _container_decorators;
    let _container_initializers = [];
    let _container_extraInitializers = [];
    var SdsContextMenu = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsContextMenu_position_accessor_storage.set(this, __runInitializers(this, _position_initializers, 'below'));
            _SdsContextMenu_offset_accessor_storage.set(this, (__runInitializers(this, _position_extraInitializers), __runInitializers(this, _offset_initializers, 0)));
            _SdsContextMenu_width_accessor_storage.set(this, (__runInitializers(this, _offset_extraInitializers), __runInitializers(this, _width_initializers, void 0)));
            _SdsContextMenu_minWidth_accessor_storage.set(this, (__runInitializers(this, _width_extraInitializers), __runInitializers(this, _minWidth_initializers, void 0)));
            _SdsContextMenu_maxHeight_accessor_storage.set(this, (__runInitializers(this, _minWidth_extraInitializers), __runInitializers(this, _maxHeight_initializers, void 0)));
            _SdsContextMenu_maxWidth_accessor_storage.set(this, (__runInitializers(this, _maxHeight_extraInitializers), __runInitializers(this, _maxWidth_initializers, void 0)));
            _SdsContextMenu_identifier_accessor_storage.set(this, (__runInitializers(this, _maxWidth_extraInitializers), __runInitializers(this, _identifier_initializers, void 0)));
            _SdsContextMenu_opened_accessor_storage.set(this, (__runInitializers(this, _identifier_extraInitializers), __runInitializers(this, _opened_initializers, false)));
            _SdsContextMenu_container_accessor_storage.set(this, (__runInitializers(this, _opened_extraInitializers), __runInitializers(this, _container_initializers, void 0)));
            this.menuItems = (__runInitializers(this, _container_extraInitializers), []);
            this.isSelectMenu = false;
            this.show = (trigger, isSelectMenu = true) => {
                this.trigger = trigger;
                this.opened = true;
                this.isSelectMenu = isSelectMenu;
                this.addEventListeners();
                // Add visible class and handle popover
                this.container.classList.add('sds-context-menu--visible');
                if (typeof this.container.showPopover === 'function') {
                    this.container.showPopover();
                }
                this.cleanupAutoUpdate = autoUpdate(trigger, this.container, this.updatePosition, {
                    animationFrame: true,
                });
                this.observeVisibility();
                // Reset scroll position to top when menu opens (only for button dropdowns, not select menus)
                if (this.container && !isSelectMenu) {
                    this.container.scrollTop = 0;
                }
                // Initialize focus after the component is fully updated (only for button dropdowns)
                if (!isSelectMenu) {
                    this.updateComplete
                        .then(() => {
                        requestAnimationFrame(() => {
                            this.initializeFocus();
                        });
                    })
                        .catch(error => {
                        console.error('Error initializing focus:', error);
                    });
                }
            };
            this.addEventListeners = () => {
                document.addEventListener('keydown', this.handleKeyDown);
                // Also add listener to the context menu container
                if (this.container) {
                    this.container.addEventListener('keydown', this.handleKeyDown);
                }
            };
            this.handleKeyDown = (event) => {
                // For select components, let them handle their own keyboard events
                // Only handle keyboard events for button dropdowns
                if (this.isSelectMenu) {
                    return;
                }
                switch (event.code) {
                    case 'Escape':
                        this.handleEscape();
                        event.stopPropagation();
                        break;
                    case 'Tab':
                        // Prevent default tab behavior when menu is open
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                    case 'Enter':
                    case 'Space':
                        this.handleEnterOrSpace();
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                    case 'ArrowUp':
                        this.handleArrowUp();
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                    case 'ArrowDown':
                        this.handleArrowDown();
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                    case 'ArrowRight':
                        this.handleArrowRight();
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                    case 'ArrowLeft':
                        this.handleArrowLeft();
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                }
            };
            this.hide = (focusTrigger = true) => {
                if (!this.opened) {
                    return;
                }
                this.cleanupAutoUpdate && this.cleanupAutoUpdate();
                this.cleanupAutoUpdate = undefined;
                if (this._observer) {
                    this._observer.disconnect();
                    this._observer = undefined;
                }
                document.removeEventListener('keydown', this.handleKeyDown);
                if (this.container) {
                    this.container.removeEventListener('keydown', this.handleKeyDown);
                }
                // Clear focus from all menu items (both regular and select items)
                cleanMenuItemsFocus(this, this.isSelectMenu);
                for (const item of this.children) {
                    item instanceof SdsContextMenuExpandableItem && item.hide();
                }
                if (this.container) {
                    this.container.classList.remove('sds-context-menu--visible');
                    if (this.container.isConnected && typeof this.container.hidePopover === 'function') {
                        this.container.hidePopover();
                    }
                }
                // Focus back to the trigger button only if requested
                if (focusTrigger && this.trigger) {
                    this.trigger.focus();
                }
                // Set opened to false before dispatching event
                this.opened = false;
                this.resetTriggerState();
                // Notify the parent dropdown that the menu is closed
                this.dispatchEvent(new CustomEvent('menu-closed', { bubbles: true }));
            };
            this.updatePosition = () => {
                this.setStyles();
                if (this.trigger) {
                    // Check if this is responsive mode and screen is <= 768px
                    const isResponsive = this.container.classList.contains('sds-context-menu--responsive');
                    const isSmallScreen = window.innerWidth <= 768;
                    computePosition(this.trigger, this.container, {
                        placement: this.position === 'below' ? 'bottom-start' : 'right-start',
                        middleware: [flip({ boundary: [] }), shift({ boundary: [] }), offset(this.offset)],
                    })
                        .then(({ x, y, placement }) => {
                        // For responsive mode on small screens, only use the y coordinate
                        // and let CSS handle the x positioning
                        if (isResponsive && isSmallScreen) {
                            this.container.style.transform = `translate(0px, ${y}px)`;
                        }
                        else {
                            this.container.style.transform = `translate(${x}px, ${y}px)`;
                        }
                        if (placement === 'bottom-start' ||
                            placement === 'right-start' ||
                            placement === 'left-start') {
                            this.container.classList.add('sds-context-menu--below');
                            this.container.classList.remove('sds-context-menu--up');
                        }
                        else if (placement === 'top-start' ||
                            placement === 'right-end' ||
                            placement === 'left-end') {
                            this.container.classList.add('sds-context-menu--up');
                            this.container.classList.remove('sds-context-menu--below');
                        }
                    })
                        .catch(console.error);
                }
            };
            this.slotChangeHandler = (event) => {
                const slot = event.target;
                const items = slot.assignedElements({ flatten: true });
                // Store the menu items for later use (both regular and select items)
                this.menuItems = items.filter(el => el.tagName === 'SDS-CM-ITEM');
                items.forEach((item, index) => {
                    if (item instanceof HTMLElement) {
                        const isDisabled = item.hasAttribute('disabled');
                        item.setAttribute('role', 'option');
                        item.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
                        // Don't set tabindex on groups - they should always be -1
                        if (item.tagName !== 'SDS-CM-GROUP') {
                            item.setAttribute('tabindex', index === 0 ? '0' : '-1');
                        }
                    }
                });
            };
        }
        /**
         * Specifies the position of the context menu relative to its trigger element.
         *
         * Defaults to `below`.
         *
         * @attr {string} position - The position of the menu.
         * Can be either `'below'` or `'beside'`.
         */
        get position() { return __classPrivateFieldGet(this, _SdsContextMenu_position_accessor_storage, "f"); }
        set position(value) { __classPrivateFieldSet(this, _SdsContextMenu_position_accessor_storage, value, "f"); }
        /**
         * Specifies the offset distance in pixels between the context menu and its trigger element.
         * This value adjusts the spacing to control how far the menu is positioned from the trigger.
         * Defaults to `0`.
         *
         * @attr {number} offset - The offset distance in pixels.
         */
        get offset() { return __classPrivateFieldGet(this, _SdsContextMenu_offset_accessor_storage, "f"); }
        set offset(value) { __classPrivateFieldSet(this, _SdsContextMenu_offset_accessor_storage, value, "f"); }
        /**
         * Specifies the width of the context menu. If not provided, the menu will use its default width.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} width - The width of the menu.
         */
        get width() { return __classPrivateFieldGet(this, _SdsContextMenu_width_accessor_storage, "f"); }
        set width(value) { __classPrivateFieldSet(this, _SdsContextMenu_width_accessor_storage, value, "f"); }
        /**
         * Specifies the minimum width of the context menu.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} min-width - The minimum width of the menu.
         */
        get minWidth() { return __classPrivateFieldGet(this, _SdsContextMenu_minWidth_accessor_storage, "f"); }
        set minWidth(value) { __classPrivateFieldSet(this, _SdsContextMenu_minWidth_accessor_storage, value, "f"); }
        /**
         * Specifies the maximum height of the context menu.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} max-height - The maximum height of the menu.
         */
        get maxHeight() { return __classPrivateFieldGet(this, _SdsContextMenu_maxHeight_accessor_storage, "f"); }
        set maxHeight(value) { __classPrivateFieldSet(this, _SdsContextMenu_maxHeight_accessor_storage, value, "f"); }
        /**
         * Specifies the maximum width of the context menu.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} max-width - The maximum width of the menu.
         */
        get maxWidth() { return __classPrivateFieldGet(this, _SdsContextMenu_maxWidth_accessor_storage, "f"); }
        set maxWidth(value) { __classPrivateFieldSet(this, _SdsContextMenu_maxWidth_accessor_storage, value, "f"); }
        /**
         * A unique identifier for the context menu.
         * This can be used to distinguish between multiple menus or to reference
         * the menu programmatically.
         *
         * Defaults to `undefined`.
         *
         * @attr {string} identifier - A unique identifier for the menu.
         */
        get identifier() { return __classPrivateFieldGet(this, _SdsContextMenu_identifier_accessor_storage, "f"); }
        set identifier(value) { __classPrivateFieldSet(this, _SdsContextMenu_identifier_accessor_storage, value, "f"); }
        get opened() { return __classPrivateFieldGet(this, _SdsContextMenu_opened_accessor_storage, "f"); }
        set opened(value) { __classPrivateFieldSet(this, _SdsContextMenu_opened_accessor_storage, value, "f"); }
        get container() { return __classPrivateFieldGet(this, _SdsContextMenu_container_accessor_storage, "f"); }
        set container(value) { __classPrivateFieldSet(this, _SdsContextMenu_container_accessor_storage, value, "f"); }
        handleArrowDown() {
            focusNextItem(this, this.isSelectMenu);
            this.requestUpdate();
            scrollFocusedItemIfNeeded(this, this.isSelectMenu);
        }
        handleArrowUp() {
            focusPreviousItem(this, this.isSelectMenu);
            this.requestUpdate();
            scrollFocusedItemIfNeeded(this, this.isSelectMenu);
        }
        handleArrowRight() {
            const menuItems = this.getMenuItems();
            const focusedItem = menuItems.find(item => item.focused);
            if (focusedItem && focusedItem instanceof SdsContextMenuExpandableItem) {
                this.openNestedMenu(focusedItem);
            }
        }
        handleArrowLeft() {
            // Check if we're in a nested menu
            const parentExpandableItem = this.findParentExpandableItem();
            if (parentExpandableItem) {
                const nestedMenu = parentExpandableItem.getMenu();
                if (nestedMenu && nestedMenu.opened) {
                    // Close the nested menu
                    nestedMenu.hide();
                    // Focus back to the parent expandable item
                    parentExpandableItem.focused = true;
                    this.requestUpdate();
                }
            }
        }
        findParentExpandableItem() {
            // Look for a parent expandable item that contains this context menu
            // The nested menu is inside the expandable item's shadow root
            const parentElement = this.parentElement;
            if (parentElement && parentElement instanceof SdsContextMenuExpandableItem) {
                return parentElement;
            }
            // If we're in a shadow root, look for the host element
            if (parentElement && parentElement.getRootNode() instanceof ShadowRoot) {
                const shadowRoot = parentElement.getRootNode();
                const hostElement = shadowRoot.host;
                if (hostElement && hostElement instanceof SdsContextMenuExpandableItem) {
                    return hostElement;
                }
            }
            return null;
        }
        handleEscape() {
            // Check if we're in a nested menu
            const parentExpandableItem = this.findParentExpandableItem();
            if (parentExpandableItem) {
                // We're in a nested menu, close it and focus back to parent
                const nestedMenu = parentExpandableItem.getMenu();
                if (nestedMenu && nestedMenu.opened) {
                    nestedMenu.hide();
                    // Focus back to the parent expandable item
                    parentExpandableItem.focused = true;
                    this.requestUpdate();
                }
            }
            else {
                // We're in the main menu, close the entire menu hierarchy
                this.hide();
            }
        }
        handleEnterOrSpace() {
            const menuItems = this.getMenuItems();
            const focusedItem = menuItems.find(item => item.focused);
            if (focusedItem && !focusedItem.disabled) {
                if (focusedItem instanceof SdsContextMenuExpandableItem) {
                    // For expandable items, open the nested menu instead of triggering click
                    this.openNestedMenu(focusedItem);
                }
                else {
                    // For regular items, call the handleClick method directly to ensure it's triggered
                    focusedItem.handleClick();
                    this.hide();
                }
            }
        }
        openNestedMenu(expandableItem) {
            var _a;
            const nestedMenu = expandableItem.getMenu();
            if (nestedMenu && !nestedMenu.opened) {
                nestedMenu.show(expandableItem, false);
                // Focus the first item in the nested menu immediately
                const nestedItems = ((_a = nestedMenu.querySelector('slot')) === null || _a === void 0 ? void 0 : _a.assignedElements()) || [];
                const firstNestedItem = nestedItems.find(item => item instanceof SdsContextMenuItem && !item.disabled);
                if (firstNestedItem) {
                    // Clear focus from current item
                    expandableItem.focused = false;
                    expandableItem.tabIndex = -1; // Remove from tab order
                    // Focus the first nested item
                    firstNestedItem.focused = true;
                    // Ensure proper focus management for screen readers
                    requestAnimationFrame(() => {
                        // Set tabindex to make it focusable
                        firstNestedItem.tabIndex = 0;
                        // Ensure the item is updated before focusing
                        firstNestedItem.requestUpdate();
                        // Add a small delay to ensure screen reader detects the change
                        setTimeout(() => {
                            // Focus the actual item, not the container
                            firstNestedItem.focus();
                        }, 50);
                    });
                    nestedMenu.requestUpdate();
                }
            }
        }
        resetTriggerState() {
            var _a;
            if (!this.trigger)
                return;
            this.trigger['opened'] = false;
            const rootNode = (_a = this.trigger) === null || _a === void 0 ? void 0 : _a.getRootNode();
            if (rootNode instanceof ShadowRoot) {
                const shadowHost = rootNode.host;
                shadowHost['opened'] = false;
            }
        }
        observeVisibility() {
            if (!this.shadowRoot || !this.trigger)
                return;
            if (this._observer) {
                this._observer.disconnect();
            }
            this._observer = new IntersectionObserver(entries => {
                const isVisible = entries.some(entry => entry.isIntersecting);
                if (!isVisible) {
                    this.hide(false); // Don't focus trigger when clicking outside
                }
            }, { threshold: 0.1 });
            this._observer.observe(this.trigger);
        }
        queryMenuChild(selector) {
            return this.querySelector(selector);
        }
        render() {
            return html `
            <div
                popover="manual"
                class="sds-context-menu"
                part="sds-context-menu"
                role="listbox"
                style="${this.maxWidth ? `max-width: ${this.maxWidth}` : ''}"
            >
                <slot id="content-container" @slotchange="${this.slotChangeHandler}"></slot>
            </div>
        `;
        }
        getMenuItems() {
            // For context menu keyboard handling, we need to get items dynamically
            // because the menu might contain either sds-cm-item or sds-cm-select-item
            const slot = this.querySelector('slot');
            if (!slot) {
                return [];
            }
            const items = [];
            const menuItems = slot.assignedElements({ flatten: true });
            for (let i = 0; i < menuItems.length; i++) {
                const menuItem = menuItems[i];
                if ((menuItem.tagName === 'SDS-CM-ITEM' ||
                    menuItem.tagName === 'SDS-CM-EXPANDABLE-ITEM') &&
                    menuItem.style.display !== 'none') {
                    items.push(menuItem);
                }
                if (menuItem.tagName === 'SDS-CM-GROUP') {
                    const group = menuItem;
                    if (group.filteredContent) {
                        group.filteredContent.forEach((groupItem) => {
                            if ((groupItem.tagName === 'SDS-CM-ITEM' ||
                                groupItem.tagName === 'SDS-CM-EXPANDABLE-ITEM') &&
                                groupItem.style.display !== 'none') {
                                items.push(groupItem);
                            }
                        });
                    }
                }
            }
            return items;
        }
        initializeFocus() {
            // Check if any menu item is already focused
            const menuItems = this.getMenuItems();
            const focusedItem = menuItems.find(item => item.focused);
            if (focusedItem) {
                // If there's a focused item, ensure it actually gets DOM focus
                focusedItem.focus();
            }
            else if (this.container) {
                // Only focus the container if no menu item is focused
                this.container.focus();
            }
            // Reset scroll position to top
            if (this.container) {
                this.container.scrollTop = 0;
            }
        }
        async connectedCallback() {
            super.connectedCallback();
            await this.updateComplete;
            this.updatePosition();
            this.hide();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.hide();
        }
        firstUpdated(_changedProperties) {
            super.firstUpdated(_changedProperties);
        }
        getMenu() {
            return this.container;
        }
        setStyles() {
            if (this.width) {
                this.getMenu().style.width = this.width;
            }
            if (this.minWidth) {
                this.getMenu().style.minWidth = this.minWidth;
            }
            if (this.maxHeight) {
                this.getMenu().style.maxHeight = this.maxHeight;
            }
        }
    };
    _SdsContextMenu_position_accessor_storage = new WeakMap();
    _SdsContextMenu_offset_accessor_storage = new WeakMap();
    _SdsContextMenu_width_accessor_storage = new WeakMap();
    _SdsContextMenu_minWidth_accessor_storage = new WeakMap();
    _SdsContextMenu_maxHeight_accessor_storage = new WeakMap();
    _SdsContextMenu_maxWidth_accessor_storage = new WeakMap();
    _SdsContextMenu_identifier_accessor_storage = new WeakMap();
    _SdsContextMenu_opened_accessor_storage = new WeakMap();
    _SdsContextMenu_container_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsContextMenu");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _position_decorators = [property()];
        _offset_decorators = [property({ type: Number })];
        _width_decorators = [property()];
        _minWidth_decorators = [property({ attribute: 'min-width' })];
        _maxHeight_decorators = [property()];
        _maxWidth_decorators = [property({ attribute: 'max-width' })];
        _identifier_decorators = [property({ type: String })];
        _opened_decorators = [property({ attribute: false })];
        _container_decorators = [query('div')];
        __esDecorate(_classThis, null, _position_decorators, { kind: "accessor", name: "position", static: false, private: false, access: { has: obj => "position" in obj, get: obj => obj.position, set: (obj, value) => { obj.position = value; } }, metadata: _metadata }, _position_initializers, _position_extraInitializers);
        __esDecorate(_classThis, null, _offset_decorators, { kind: "accessor", name: "offset", static: false, private: false, access: { has: obj => "offset" in obj, get: obj => obj.offset, set: (obj, value) => { obj.offset = value; } }, metadata: _metadata }, _offset_initializers, _offset_extraInitializers);
        __esDecorate(_classThis, null, _width_decorators, { kind: "accessor", name: "width", static: false, private: false, access: { has: obj => "width" in obj, get: obj => obj.width, set: (obj, value) => { obj.width = value; } }, metadata: _metadata }, _width_initializers, _width_extraInitializers);
        __esDecorate(_classThis, null, _minWidth_decorators, { kind: "accessor", name: "minWidth", static: false, private: false, access: { has: obj => "minWidth" in obj, get: obj => obj.minWidth, set: (obj, value) => { obj.minWidth = value; } }, metadata: _metadata }, _minWidth_initializers, _minWidth_extraInitializers);
        __esDecorate(_classThis, null, _maxHeight_decorators, { kind: "accessor", name: "maxHeight", static: false, private: false, access: { has: obj => "maxHeight" in obj, get: obj => obj.maxHeight, set: (obj, value) => { obj.maxHeight = value; } }, metadata: _metadata }, _maxHeight_initializers, _maxHeight_extraInitializers);
        __esDecorate(_classThis, null, _maxWidth_decorators, { kind: "accessor", name: "maxWidth", static: false, private: false, access: { has: obj => "maxWidth" in obj, get: obj => obj.maxWidth, set: (obj, value) => { obj.maxWidth = value; } }, metadata: _metadata }, _maxWidth_initializers, _maxWidth_extraInitializers);
        __esDecorate(_classThis, null, _identifier_decorators, { kind: "accessor", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, get: obj => obj.identifier, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, _identifier_initializers, _identifier_extraInitializers);
        __esDecorate(_classThis, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
        __esDecorate(_classThis, null, _container_decorators, { kind: "accessor", name: "container", static: false, private: false, access: { has: obj => "container" in obj, get: obj => obj.container, set: (obj, value) => { obj.container = value; } }, metadata: _metadata }, _container_initializers, _container_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsContextMenu = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsContextMenu = _classThis;
})();
export { SdsContextMenu };
